<template>
  <div id="content">
    <link rel="stylesheet" href="/themes/ito/css/notification.css">

    <div class="container">

      <div id="notification" class="card" style="height: calc(100vh - 190px);">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">{{ $t('inbox') }}</span>
          </h5>

          <div class="card-content">

            <div class="nano" style="height: calc(100vh - 275px)">
                <div class="nano-content">

                  <template v-if="isLoading == false">
                    <div class="notification-list" v-if="inboxes.length > 0">
                      <div :class="inbox.status == 1?'notification-item is-read':'notification-item'"
                          v-for="(inbox, index) in inboxes">
                        <div class="title">
                          <h4>{{ inbox.title }}</h4>
                          <span class="time">{{ inbox.time | convertUnitToTime }}</span>
                        </div>
                        <div class="desc">
                          {{ inbox.content }}
                        </div>

                        <div class="tools" v-if="inbox.status != 1">
                          <button class="btn btn-default btn-notification-open" @click="readInbox(inbox)">
                            {{ $t('open') }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="notification-list" v-else>
                      <div class="notification-list-empty">
                        <div class="message">
                          {{ $t('no_inbox') }}
                        </div>
                        <img src="/themes/ito/images/notification-empty.svg" alt="">
                      </div>
                    </div>
                  </template>

                </div>
            </div>


          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";
import {pushQueries} from '../../utils/utils'
import {mapGetters} from 'vuex'
import {getInboxs, readInbox} from "../../models/inbox";
import {claimDailyBonus} from "../../models/reward";

export default {
  name: "Inbox",
  title: 'Inbox',

  data() {
    return {
      inboxes: [],
      isLoading: true
    };
  },

  created() {
    this.$store.commit('setMenuActive', 'inbox');

    this.fetch();
  },

  methods: {
    fetch(page = 1) {
      const that = this;

      this.page = page;

      const params = {
        page: this.page,
      };

      pushQueries(this.$router, '/inbox', params);

      axios.all([
        getInboxs(params),
      ]).then(axios.spread((inbox_response) => {
        that.isLoading = false;

        //that.$store.commit("setLoading", false);

        if (inbox_response.data.code != 0) {
          return;
        }

        that.inboxes = inbox_response.data.results ? inbox_response.data.results.mails : [];

        this.$nextTick(function () {
            initNanoScroller();
        })                
      }));
    },

    readInbox(inbox) {
      const that = this;

      that.$store.commit("setLoading", true);

      readInbox({
        id: inbox.id,
        //is_raw: true
      }).then((response) => {
        that.$store.commit("setLoading", false);

        console.log(response);

        if (response.data.code != 0) {
          return;
        }

        inbox.status = 1; 
      }).catch(({response}) => {
        that.$store.commit("setLoading", false);

        console.error(response);
      });
    }
  }
}
</script>

<style scoped>

</style>
